import { gsap } from "../node_modules/gsap/all.js";
import { ScrollTrigger } from "../node_modules/gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "../node_modules/gsap/ScrollToPlugin.js";
//import LocomotiveScroll from "locomotive-scroll";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
/*
const locoScroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  smooth: true,
});
locoScroll.on("scroll", ScrollTrigger.update);

ScrollTrigger.scrollerProxy("[data-scroll-container]", {
  scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
  },
  getBoundingClientRect() {
    return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
  },
  pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed",
});
ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
ScrollTrigger.refresh();
*/
$ = jQuery;

$("#wrapper").imagesLoaded(function () {
  $("body").addClass("is-loaded");

  //do gsap
  execGsap();

  //hamburger
  $("#hamburger").on("click", function () {
    $("body").toggleClass("drawer-open");
  });
  $(".drawer-overlay").on("click", function () {
    $("body").removeClass("drawer-open");
  });

  //news-topics
  $("#news-topics ul.nav li a").on("click", function () {
    var target = $(this).data("target");
    $(".news-content").removeClass("is-active");
    $("#" + target).addClass("is-active");
    $("#news-topics ul.nav li a").removeClass("is-active");
    $(this).addClass("is-active");
    return false;
  });
});

function execGsap() {
  const wid = $(window).width();
  const container_wrapper = document.querySelector(".home_spot--wrapper");
  const container = document.querySelector(".home_spot");
  const header = document.querySelector(".header");
  const spots = document.querySelectorAll(".spot");
  const spot01 = document.querySelector(".spot01");
  const spot02 = document.querySelector(".spot02");
  const spot03 = document.querySelector(".spot03");
  const spot04 = document.querySelector(".spot04");
  const spot_bg = document.querySelector(".spot_bg");
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;

  if (wid > 767) {
    // 横スライド
    gsap.to(spots, {
      // spotsに対して以下のアニメーションを設定
      xPercent: -100 * spots.length, // 横に動く方向と距離（この例は右側にスライドの合計幅より少し横スクロール）
      ease: "linear", //アニメーションの種類をnoneにする
      scrollTrigger: {
        trigger: container, //containerに到達したら発火
        pin: true, // ピン留をtrueにすることでcontainerの縦スクロールが止まる
        scrub: true, //スクロール当たりのアニメーションが動く時間
        start: "top top",
        end: "+=" + containerWidth, // 横スクロールが終わる地点
        // anticipatePin: 1, // ピン留のタイミング
        invalidateOnRefresh: true, // リサイズ時の調整でtrueにしておく
        toggleClass: {
          targets: header,
          className: "hide",
        },
        // markers: true,
      },
    });

    // 後ろのスライドの切り替え
    const initScrollTrigger = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: "+=" + containerWidth,
        scrub: true,
      },
    });
    initScrollTrigger
      .add(() => {
        spot01.classList.add("active");
      })
      .to(".spot_bg .bg01", { ease: "linear", clipPath: "inset(0% 100% 0% 0%)" })
      .add(() => {
        spot02.classList.add("active");
      })
      .to(".spot_bg .bg02", { ease: "linear", clipPath: "inset(0% 100% 0% 0%)" })
      .add(() => {
        spot03.classList.add("active");
      })
      .to(".spot_bg .bg03", { ease: "linear", clipPath: "inset(0% 100% 0% 0%)" })
      .add(() => {
        spot04.classList.add("active");
      })
      .to(".spot_bg .bg04", { ease: "linear", clipPath: "inset(0% 0% 0% 0%)" });
  } else {
    gsap.to(spots, {
      // spotsに対して以下のアニメーションを設定
      ease: "linear", //アニメーションの種類をnoneにする
      scrollTrigger: {
        trigger: spot_bg, //containerに到達したら発火
        pin: true, // ピン留をtrueにすることでcontainerの縦スクロールが止まる
        scrub: true, //スクロール当たりのアニメーションが動く時間
        start: "top top",
        end: "+=" + containerHeight, // 横スクロールが終わる地点
        invalidateOnRefresh: true, // リサイズ時の調整でtrueにしておく
      },
    });

    initScrollTrigger = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: "+=" + containerHeight,
        scrub: true,
      },
    });
    initScrollTrigger
      .add(() => {
        spot01.classList.add("active");
      })
      .to(".spot_bg .bg01", { ease: "linear", clipPath: "inset(0% 0% 100% 0%)" })
      .add(() => {
        spot02.classList.add("active");
      })
      .to(".spot_bg .bg02", { ease: "linear", clipPath: "inset(0% 0% 100% 0%)" })
      .add(() => {
        spot03.classList.add("active");
      })
      .to(".spot_bg .bg03", { ease: "linear", clipPath: "inset(0% 0% 100% 0%)" })
      .add(() => {
        spot04.classList.add("active");
      })
      .to(".spot_bg .bg04", { ease: "linear", clipPath: "inset(0% 0% 0% 0%)" });
  }
}

let ignitionTimeoutID;
let isWheel = true;
let isTrackPad = false;

if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  document.querySelector("body").addEventListener("mousewheel", disableScroll, { passive: false });
}

function disableScroll(e) {
  const wheelDeltaY = e.wheelDeltaY;
  if (isWheel) e.preventDefault();

  if (Math.abs(wheelDeltaY) < 10) {
    isWheel = false;
    isTrackPad = true;

    clearTimeout(ignitionTimeoutID);
    ignitionTimeoutID = setTimeout(() => {
      isTrackPad = false;
    }, 1500);
  } else {
    if (!isTrackPad) {
      isWheel = true;

      let direction = `-=${Math.abs(wheelDeltaY)}px`;
      if (wheelDeltaY < 0) direction = `+=${Math.abs(wheelDeltaY)}px`;
      gsap.to(window, {
        scrollTo: { y: direction, autoKill: false },
        duration: 0.5,
        ease: "sine.out",
      });
    }
  }
}
